import { Navigate, Outlet } from "react-router-dom";
import { getAccessToken, getDataSso } from '../../utils';
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import TabToTop from '../../components/TabToTap'
import { useLocation } from 'react-router-dom';
import Main from "../main/index";
import { useEffect } from "react";

const RequireAuth = () => {

  const location = useLocation();
  const { is_used_sso, url_login_sso } = getDataSso();
  const token = getAccessToken();

  // Move DOM manipulation to useEffect
  useEffect(() => {
    const body = document.querySelector("body");
    body.classList.remove("page-style1", "bg-style", "error-page");
    body.classList.add("main-body", "app", "sidebar-mini", "light-mode", "ltr");
  }, []);

  // If not logged in
  if (!token) {

    if (is_used_sso && url_login_sso) {
      window.location.replace(url_login_sso);
      return null; // stop render
    }

    return <Navigate to="/login" replace />;
  }

  // If logged in
  return (
    <div>
      <div>
        <Outlet />
      </div>
      {location.pathname === '/profile/detail' && <TabToTop />}
    </div>
  );
};

export default RequireAuth;